var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('metainfo',{scopedSlots:_vm._u([{key:"title",fn:function(ref){
var content = ref.content;
return [_vm._v(_vm._s(content ? (content + " | SITE_NAME") : "SITE_NAME"))]}}])}),_c('NavBar'),_c('v-main',[_c('router-view'),_c('Footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }